import { style, keyframes } from '@vanilla-extract/css'

const slide = keyframes({
  '0%': { transform: 'translateX(0)' },
  '100%': { transform: 'translateX(calc(-360px * 4))' },
})

const rotate = keyframes({
  '0%': { transform: 'rotate(0deg)' },
  '100%': { transform: 'rotate(360deg)' },
})

const section = style({
  backgroundColor: '#F2F1EF',
  '@media': {
    '(min-width: 960px)': {
      paddingBottom: '64px',
    },
  },
})

const headline = style({
  fontSize: '23px',
  fontWeight: '700',
  lineHeight: '2.1',
  textAlign: 'center',
  textDecorationLine: 'underline',
  textDecorationStyle: 'dotted',
  textUnderlineOffset: '45%',
  textDecorationThickness: '12%'
})

const heading = style({
  fontSize: '19px',
  fontWeight: '700',
  lineHeight: '1.5',
  textAlign: 'center',
})

const text = style({
  fontSize: '16px',
  lineHeight: '1.6',
  textAlign: 'center',
})

const carousel = style({
  overflowX: 'hidden',
	position: 'relative',
})

const images = style({
  display: 'flex',
  animationName: slide,
  animationDuration: '20s',
  animationIterationCount: 'infinite',
  animationTimingFunction: 'linear',
})

const image = style({
  width: '344px',
  height: '430px',
  borderRadius: '24px',
  marginRight: '16px',
})

const otoku = style({
  position: 'relative',
  width: '72px',
  height: '72px',
  fontWeight: '700',
  lineHeight: '1.2',
  color: '#E46327',
})

const otokuBackground = style({
  position: 'absolute',
  width: '72px',
  height: '72px',
  animationName: rotate,
  animationDuration: '20s',
  animationIterationCount: 'infinite',
  animationTimingFunction: 'linear',
})

const priceText = style({
  fontFamily: 'Noto Sans Variable, sans-serif',
  fontSize: '14px',
  lineHeight: '1.5',
})

const price = style({
  fontFamily: 'Noto Sans Variable, sans-serif',
  color: '#E46327',
  fontSize: '12px',
  fontWeight: '700',
  lineHeight: '1.5',
})

const bullets = style({
  listStyleType: 'disc',
  paddingLeft: '24px',
  fontSize: '15px',
  lineHeight: '1.5',
  width: '100%',
})

export const styles = {
  section,
  headline,
  heading,
  text,
  carousel,
  images,
  image,
  otoku,
  otokuBackground,
  priceText,
  price,
  bullets,
}
